@if (formControl()) {
<div class="slider form-group">
    <div class="info">
        <label class="info-label">{{meta().info}}</label>
    </div>
    <mat-slider class="input-slider" matSuffix [min]="meta().min" [max]="meta().max" [step]="meta().step" discrete>
        <input matInput matSliderThumb [formControl]="formControl()!" [readonly]="meta().readonly || readonly()">
    </mat-slider>
    @if (formControl()?.hasError('form')) {
    <mat-error>
        {{formError}}
    </mat-error>
    }
</div>
}
